module.exports = __webpack_public_path__ + "static/media/awards_19.0738610e.jpg";